import React from 'react';

import { HeaderSkeleton } from './HeaderSkeleton';
import { HeaderGuestButtons } from './HeaderGuestButtons';
import { HeaderUserButtons } from './HeaderUserButtons';

import { HeaderAssets, HeaderUser, KycAndFeaturesConfig } from '../Header.types';
import { ThemeType } from 'src/packages/theme';

export interface HeaderButtonsProps {
  hideRightNav?: boolean;
  assets?: HeaderAssets;
  theme: ThemeType;
  userLoading: boolean;
  user?: HeaderUser;
  logout?: () => void;
  copyToClipboard?: (value: string) => void;
  kycAndFeaturesConfig?: KycAndFeaturesConfig;
}

export const HeaderButtons = ({
  userLoading,
  user,
  hideRightNav,
  assets,
  logout,
  copyToClipboard,
  theme,
  kycAndFeaturesConfig,
}: HeaderButtonsProps) => {
  if (userLoading) return <HeaderSkeleton />;
  if (!user) return <HeaderGuestButtons />;

  return (
    <HeaderUserButtons
      hideRightNav={hideRightNav}
      assets={assets}
      theme={theme}
      user={user}
      logout={logout}
      copyToClipboard={copyToClipboard}
      kycAndFeaturesConfig={kycAndFeaturesConfig}
    />
  );
};
